import { Fragment } from 'react';

import useClubGroupListEdit from './UseClubGroupListEdit';

import ClubGroupsLoadingModal from '../../components/dialogs/loadingModal/ClubGroupsLoadingModal';

import Headings from '@usas/ui-web/components/headings/Headings';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import GroupInfoForm from '@usas/ui-web/components/forms/groups/GroupInfoForm';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ClubGroupListEdit = () => {
  const {
    isLoading,
    state,
    formState,
    errorState,
    handleSubmit,
    onFormValueChanged,
    onBackClicked,
    orgUnitId
  } = useClubGroupListEdit();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Edit List Group</Headings.H3>
        </div>
      </div>
      <form onSubmit={handleSubmit} noValidate>
        <GroupInfoForm
          formState={formState}
          errorState={errorState}
          orgUnitId={orgUnitId}
          onFormValueChanged={onFormValueChanged} />
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <PrimaryButton type="submit">Save</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>
            {errorState && errorState.errorOnSubmitAction
              && <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction}</p>
            }
          </div>
        </div>
      </form>
      <ClubGroupsLoadingModal
        isLoading={isLoading}
        isError={state.pageErrorMessage !== ''}
        errorMessage={state.pageErrorMessage} />
    </Fragment>
  );
};

export default ClubGroupListEdit;